import React from "react";
import { CustomIconProps } from "./add-01-solid-standard";

const CloseIcon: React.FC<CustomIconProps> = ({
  size = 48,
  color = "#000000",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    color={color}
    fill={"none"}
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.11612 5.11612C5.60427 4.62796 6.39573 4.62796 6.88388 5.11612L12 10.2322L17.1161 5.11612C17.6043 4.62796 18.3957 4.62796 18.8839 5.11612C19.372 5.60427 19.372 6.39573 18.8839 6.88388L13.7678 12L18.8839 17.1161C19.372 17.6043 19.372 18.3957 18.8839 18.8839C18.3957 19.372 17.6043 19.372 17.1161 18.8839L12 13.7678L6.88388 18.8839C6.39573 19.372 5.60427 19.372 5.11612 18.8839C4.62796 18.3957 4.62796 17.6043 5.11612 17.1161L10.2322 12L5.11612 6.88388C4.62796 6.39573 4.62796 5.60427 5.11612 5.11612Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
